<script lang="ts">
  import Skeleton from '@/lib/components/ui/skeleton/skeleton.svelte';

  export let numCards = 6;

  let containerSize: ResizeObserverSize[] | null = null;
  let containerWidth: number | null = null;
  $: if (containerSize && containerSize[0]) containerWidth = containerSize[0].inlineSize;

</script>

<div class='w-full relative' bind:borderBoxSize={containerSize}>
  <div class='whitespace-nowrap flex px-4 gap-4 min-w-0 w-full overflow-hidden flex-row'>
    {#each Array(numCards) as _, i}
      <Skeleton class={containerWidth < 600 ? 'min-w-36 w-36 h-30' : 'min-w-72 w-72 h-60'} style="flex: 0 0 auto;"/>
    {/each}
  </div>
  <div class='absolute inset-0 pointer-events-none shadow-[inset_-20px_0_20px_0px_rgba(249,249,249,1)]'/>
</div>
